import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RouteTrackingService {
    private _isHomePage = new BehaviorSubject<boolean>(false);
    private _showHeaderContent = new BehaviorSubject<boolean>(false);
    
    public isHomePage$ = this._isHomePage.asObservable();
    public showHeaderContent$ = this._showHeaderContent.asObservable();

    setHomePage(isHomePage: boolean): void {
        this._isHomePage.next(isHomePage);
    }

    setShowHeaderContent(show: boolean): void {
        this._showHeaderContent.next(show);
    }

    getCurrentValue(): boolean {
        return this._isHomePage.value;
    }
}
